<template>
    <div class="c-header-panel" id="c-header-panel">
        <el-tooltip effect="dark" content="创作中心" placement="bottom" popper-class="c-header-tooltip">
            <a class="u-post" :href="url">
                <svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" v-bind:class="'u-add'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M193.16 190.17a9.94 9.94 0 01-9.93 9.92H41.17V69.41a9.94 9.94 0 019.93-9.92h41.28v-12H51.1a22 22 0 00-21.93 21.92v142.68h154.06a22 22 0 0021.93-21.92v-48.34h-12z"/><path d="M205.91 35.12a24.68 24.68 0 00-34.85 0L163 43.24l-77.59 77.54a5.93 5.93 0 00-1.64 3.07L75 167.76l43.88-8.76a6 6 0 003.07-1.64l77.54-77.54 8.12-8.12a24.67 24.67 0 000-34.84zM93.33 137.19l12.21 12.21-15.27 3.06zm24.38 7.41L98.14 125l69.05-69 19.58 19.57zm81.41-81.41l-3.87 3.87-19.57-19.58 3.87-3.87a12.64 12.64 0 0117.87 0l1.7 1.7a12.66 12.66 0 010 17.88z"/></svg>
            </a>
        </el-tooltip>
    </div>
</template>

<script>
import { __Links } from "@jx3box/jx3box-common/data/jx3box.json";
export default {
    name: "publish",
    data: function () {
        return {
            url: __Links.dashboard.publish,
        };
    },
};
</script>
